import axios from "axios";
import type {CouponGift} from "offers/ladder/currentLadderOffer";

export interface PromoGift {code: string; discountsLeft?: number; gift: CouponGift}
// Bound to the API-generated response when the local API exports its schema.
interface PromoOfferResponse {
	code: string; targetPlan: "PLUS"; currency: string; amountOff: number; firstMonth: number;
	renewal: number; discountsLeft: number | null; maxHostedUploadBytes: number;
}

export class PromoOfferApi {
	/** No caching or issuance: opening the link consumes no redemption and a later visit checks again. */
	static async resolve(code: string, currency: string): Promise<PromoGift | null> {
		let offer: PromoOfferResponse | null;
		try {
			const {data} = await axios.get<PromoOfferResponse | null>("/pay/promo-offer", {params: {code, currency: currency.toUpperCase()}});
			offer = data;
		} catch {
			// A lookup failure says nothing about availability. Do not advertise an unverified offer.
			return null;
		}
		if (offer === null || offer.code !== code || offer.targetPlan !== "PLUS" || offer.currency.toLowerCase() !== currency
			|| (offer.discountsLeft != null && (!Number.isInteger(offer.discountsLeft) || offer.discountsLeft <= 0))
			|| !Number.isFinite(offer.amountOff) || offer.amountOff <= 0 || !Number.isFinite(offer.renewal) || offer.renewal <= 0
			|| !Number.isFinite(offer.firstMonth) || offer.firstMonth < 0
			// Displayed as the plan's transfer size — the one figure that was reaching the view unchecked.
			|| !Number.isFinite(offer.maxHostedUploadBytes) || offer.maxHostedUploadBytes <= 0) return null;
		return {code: offer.code, ...(offer.discountsLeft == null ? {} : {discountsLeft: offer.discountsLeft}), gift: {
			targetPlan: "plus", currency, discount: {kind: "amount", amountOff: offer.amountOff},
			firstMonth: offer.firstMonth, renewal: offer.renewal, maxHostedUploadBytes: offer.maxHostedUploadBytes, isUpgrade: false,
		}};
	}
}
